import { FormattedMessage, useIntl } from 'react-intl'

import { Alert, THEME, ThemeProvider, Typography, useTheme } from '@themenu/design-system'

export type GlobalError = {
  globalErrorMessage: ErrorProps
}

export type ErrorProps = {
  message: string
  title: string
}

export const AlertError = ({ globalErrorMessage }: GlobalError): JSX.Element => {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <ThemeProvider theme={THEME.LIGHT}>
      <Alert mt={16} severity="error">
        {globalErrorMessage.title && (
          <Typography variant="body" weight="medium">
            {intl.formatMessage({ id: globalErrorMessage.title })}
          </Typography>
        )}

        <Typography variant="body" color={theme.colors.content.subdued}>
          <FormattedMessage
            id={globalErrorMessage.message}
            values={{
              div: (chunks) => <div>{chunks}</div>,
              p: (chunks) => <p>{chunks}</p>,
              // This feature simply make the text clickable, it takes 3 parameters separated by a pipe (|):
              // text to display, url to redirect and the target value.
              // only the text parameter is mandatory
              clickable: (chunks) => {
                const chunk = chunks[0] as string
                const [text, url, target] = chunk.split('|')
                return (
                  <a href={url || text} target={target || '_self'} rel="noreferrer">
                    {text}
                  </a>
                )
              },
            }}
          />
        </Typography>
      </Alert>
    </ThemeProvider>
  )
}
